import { createTheme } from '@mui/material/styles';

import { InputsOverrides } from './componentOverrides/Inputs';
import { CssBaselineOverrides } from './componentOverrides/CssBaseline';
import { NavigationOverrides } from './componentOverrides/Navigation';
import { CardOverrides } from './componentOverrides/Card';
import { DialogOverrides } from './componentOverrides/Dialog';
import { Tooltip } from './componentOverrides/Tooltip';
import { ToggleButtonOverrides } from './componentOverrides/ToggleButton';
import { SvgIconOverrides } from './componentOverrides/SvgIcon';
import { IconButtonOverrides } from './componentOverrides/IconButton';
import { MenuOverrides } from './componentOverrides/Menu';

import {
  colorSchemes,
  typography,
  shadows,
  shape,
  spacing,
  breakpoints,
  customSpacing,
} from './settings';

export const theme = createTheme({
  // For more details about CSS variables configuration, see https://mui.com/material-ui/customization/css-theme-variables/configuration/
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme',
    cssVarPrefix: 'nivea',
  },
  colorSchemes, // Recently added in v6 for building light & dark mode app, see https://mui.com/material-ui/customization/palette/#color-schemes
  typography,
  shadows,
  shape,
  ...spacing,
  breakpoints,
  customSpacing,
  components: {
    ...InputsOverrides,
    ...CssBaselineOverrides,
    ...NavigationOverrides,
    ...CardOverrides,
    ...DialogOverrides,
    ...Tooltip,
    ...ToggleButtonOverrides,
    ...SvgIconOverrides,
    ...IconButtonOverrides,
    ...MenuOverrides,
  },
});
